import classNames from "classnames";
import { useFieldContext } from "./FieldContext";
import s from "./FieldLabel.module.scss";

export function FieldLabel() {
    const { fieldHtmlId, fieldConfig } = useFieldContext();

    return (
        <label htmlFor={fieldHtmlId} className={classNames({ [s.required!]: fieldConfig.required })}>
            {fieldConfig.label}
        </label>
    );
}
